"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var hooks_1 = require("preact/hooks");
var TripDetails_1 = require("./TripDetails");
var GlobalGapDetails_1 = require("./GlobalGapDetails");
var StudyAbroadDetails_1 = require("./StudyAbroadDetails");
var lib_1 = require("../lib");
var hooks_2 = require("../hooks");
var CartProvider_1 = require("./CartProvider");
function chunkArray(array, chunkSize) {
    var chunks = new Array();
    for (var i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
}
/**
 * Finds the product line ID associated with a given trip type ID.
 * Used if we are passed a trip type via URL query in order to find the associated product line
 */
function findProductLineIdByTripTypeId(productLines, tripTypeId) {
    var productLine = productLines.find(function (productLine) { return productLine.tripTypeIds.includes(tripTypeId); });
    if (productLine) {
        return productLine.id;
    }
    else {
        console.error("Product line not found for trip type id: ".concat(tripTypeId));
        return '';
    }
}
function TripSelect(_a) {
    var _this = this;
    var _b, _c;
    var productLines = _a.productLines, studyAbroadTripTypeId = _a.studyAbroadTripTypeId;
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    // We can accept either a tripId (trip type ID
    // or productId (product type id) in the URL Querystring
    var queryTripTypeId = (_b = urlParams.get('tripId')) !== null && _b !== void 0 ? _b : '';
    var defaultProductLineId = '';
    if (queryTripTypeId) {
        defaultProductLineId = findProductLineIdByTripTypeId(productLines, queryTripTypeId);
    }
    var queryProductLineId = (_c = urlParams.get('productId')) !== null && _c !== void 0 ? _c : '';
    if (queryProductLineId) {
        defaultProductLineId = queryProductLineId;
    }
    var _d = (0, hooks_1.useState)(), defaults = _d[0], setDefaults = _d[1];
    var _e = (0, hooks_1.useState)(false), queryStringApplied = _e[0], setQueryStringApplied = _e[1];
    var _f = (0, hooks_1.useState)(defaultProductLineId), selectedProductLineId = _f[0], setSelectedProductLineId = _f[1];
    var windowSize = (0, hooks_2.useWindowSize)();
    var productLinesChunkSize = windowSize.width < 788 ? 1 : 2;
    var productLinesChunked = chunkArray(productLines, productLinesChunkSize);
    var selectedBtnRef = (0, hooks_1.useRef)(null);
    var setCart = (0, hooks_1.useContext)(CartProvider_1.CartContext).setCart;
    var handleCartItemRemoved = function (event) {
        setCart(function (prevCart) {
            return prevCart.filter(function (cartItem) { return cartItem.cartId !== event.detail.cartItemId; });
        });
    };
    (0, hooks_1.useEffect)(function () {
        window.addEventListener('paCartItemRemoved', handleCartItemRemoved);
        return function cleanup() {
            window.removeEventListener('paCartItemRemoved', handleCartItemRemoved);
        };
    }, []);
    (0, hooks_1.useEffect)(function () {
        var _a, _b, _c, _d;
        // Flexi date example ?tripId=10006&destinationId=112&projectId=3&startDate=2026-12-12&durationDays=14
        // Fixed date example ?tripId=10014&destinationId=112&projectId=538&startDate=2025-06-02&durationDays=28
        var startDate = (_a = urlParams.get('startDate')) !== null && _a !== void 0 ? _a : '';
        // If the date is backwards, reverse it
        var startsWithYear = startDate && startDate.match(/^\d{4}/);
        if (startDate && !startsWithYear) {
            startDate = startDate.split('-').reverse().join('-');
        }
        //Ensure months and days are padded with zeros
        var dateParts = startDate.split('-');
        if (dateParts.length === 3) {
            var year = dateParts[0];
            var month = dateParts[1].padStart(2, '0');
            var day = dateParts[2].padStart(2, '0');
            startDate = "".concat(year, "-").concat(month, "-").concat(day);
        }
        setDefaults({
            destinationId: (_b = urlParams.get('destinationId')) !== null && _b !== void 0 ? _b : '',
            projectId: (_c = urlParams.get('projectId')) !== null && _c !== void 0 ? _c : '',
            startDate: startDate !== null && startDate !== void 0 ? startDate : '',
            durationDays: (_d = urlParams.get('durationDays')) !== null && _d !== void 0 ? _d : '',
        });
    }, []);
    (0, hooks_1.useEffect)(function () {
        if (!queryStringApplied) {
            setQueryStringApplied(true);
        }
        else {
            setDefaults({});
        }
    }, [selectedProductLineId]);
    (0, hooks_1.useEffect)(function () {
        if (selectedProductLineId && selectedBtnRef.current && !(0, lib_1.isVisibleInViewport)(selectedBtnRef.current)) {
            (0, lib_1.scrollToElement)(selectedBtnRef.current);
        }
    }, [selectedBtnRef.current]);
    var handleSelectProductLine = function (value) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (value === selectedProductLineId) {
                setSelectedProductLineId('');
            }
            else {
                setSelectedProductLineId(value);
            }
            return [2 /*return*/];
        });
    }); };
    var getButtonClass = function (productLineId) {
        return selectedProductLineId === productLineId
            ? "trip-selector__button trip-selector__button--selected"
            : "trip-selector__button";
    };
    var renderDetailsComponent = function (productLine, defaults) {
        var isProductLineStudyAbroad = productLine.tripTypeIds.length === 1 && productLine.tripTypeIds[0] === studyAbroadTripTypeId;
        if (isProductLineStudyAbroad) {
            return (0, jsx_runtime_1.jsx)(StudyAbroadDetails_1.default, { tripTypeId: productLine.tripTypeIds[0] });
        }
        else if (productLine.isGlobalGap) {
            return (0, jsx_runtime_1.jsx)(GlobalGapDetails_1.default, { tripTypeId: productLine.tripTypeIds[0] });
        }
        else {
            return ((0, jsx_runtime_1.jsx)(TripDetails_1.default, { productLineId: productLine.id, defaults: defaults, studyAbroadTripTypeId: studyAbroadTripTypeId }));
        }
    };
    var getTripSelectorClass = selectedProductLineId ? 'trip-selector trip-selector--has-selection' : 'trip-selector';
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: getTripSelectorClass }, { children: productLinesChunked.map(function (chunk) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "trip-selector__group" }, { children: chunk.map(function (productLine) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "trip-selector__trip" }, { children: (0, jsx_runtime_1.jsxs)("button", __assign({ type: "button", className: getButtonClass(productLine.id), onClick: function () { return handleSelectProductLine(productLine.id); }, ref: productLine.id === selectedProductLineId ? selectedBtnRef : null }, { children: [productLine.logo && ((0, jsx_runtime_1.jsx)("img", { src: productLine.logo, alt: "Trip logo", width: "63", height: "63" })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", __assign({ class: "trip-selector__button-title" }, { children: productLine.name })), (0, jsx_runtime_1.jsx)("p", __assign({ class: "trip-selector__button-description" }, { children: productLine.description }))] })] })) }), productLine.id)); }) })), chunk.map(function (productLine) {
                    return selectedProductLineId === productLine.id && ((0, jsx_runtime_1.jsx)("div", { children: renderDetailsComponent(productLine, defaults) }));
                })] })); }) })));
}
exports.default = TripSelect;
